import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLogstashComponent } from './simple-icons-logstash.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLogstashComponent ],
    exports:      [ SimpleIconsLogstashComponent ],
    bootstrap:    []
})
export class SimpleIconsLogstashModule {}
